import { SortType } from "../SortType";

export enum WalletTransactionType {
  CREDIT = "credit",
  DEBIT = "debit",
}

export interface WalletTransactionApiRow {
  id: number;
  transaction_type: WalletTransactionType;
  batch_id: number | null;
  amount: number;
  balance_after: number;
  source: string | null;
  shipment_id: number | null;
  partner_order_id: string | null;
  performed_by_user_id: number | null;
  performed_by_user_name: string | null;
  performed_by_user_email: string | null;
  performed_by_admin_id: number | null;
  admin_name: string | null;
  sent_to: string | null;
  created_date: Date | string;
}

export interface WalletTransactionListQuery {
  wallet_id: number;
  type?: WalletTransactionType;
  search?: string;
  sort_type: SortType;
  start_date?: string;
  end_date?: string;
  page_no: number;
  limit: number;
}

export const buildDefaultWalletTransactionQuery = (
  walletId: number,
): WalletTransactionListQuery => ({
  wallet_id: walletId,
  page_no: 1,
  limit: 30,
  sort_type: SortType.DESC,
});

export type WalletTransactionDownloadResult =
  | { type: "file"; data: Blob; filename?: string }
  | { type: "email"; message: string };
